import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AppSettings } from 'app/app-settings';
import { interval } from 'rxjs/observable/interval';

@Component({
  selector: 'app-psp-no-plan-view',
  templateUrl: './psp-no-plan-view.component.html',
  styleUrls: ['./psp-no-plan-view.component.css']
})
export class PspNoPlanViewComponent {
  @Input() gmatPlanExecutionState = '';
  psp_url: string = AppSettings.gfePSPUrl;
  @ViewChild('welcomeVideo') welcomeVideo:ElementRef = null;
  assetLocation = this.psp_url+'/assets/';
  videoUrl: string = this.psp_url + '/assets/videos/Welcome_screen.mp4';
  posterUrl: string = this.psp_url + '/assets/images/Welcome_screen_PosterImage.png';
  interval$ = interval(200);

  constructor() {}

  ngAfterViewInit(): void {
    const subs = this.interval$.subscribe(()=>{
      const video = (this.welcomeVideo.nativeElement as HTMLVideoElement);
      const counter = video.readyState;
      if(counter === 4){
        video.muted = true;
        video.play();
        subs.unsubscribe();
      }
    });
  }
  createPlan(){
    window.open(AppSettings.gfePSPUrl, '_blank');
  }
}
